import { gql } from "apollo-boost";

export const CREATE_MANY_PURCHASE_ORDER_AND_PURCHASE_ORDER_DETAIL = gql`
mutation CreateManypurchaseorderWithpurchaseorderdetail($data: ManyPurchaseOrderWithPurchaseOrderDetailInput) {
  createManypurchaseorderWithpurchaseorderdetail(data: $data) {
    id
    amount
    totalPrice
    sumPriceBaht
    sumPriceUsd
    change
    currency
    receivedMoney
    sumPrice
    payment
    isPaymented
    code
    rateBaht
    rateUsd
  }
}
`
export const CREATE_MANY_PURCHASE_V2 = gql`
  mutation CreateManyPurchaseV2($data: ManyPurchaseOrderWithPurchaseOrderDetailInput) {
    createManyPurchaseV2(data: $data)
  }
`

export const BUY_PURCHASE_ORDER = gql`
mutation BuyPurchaseOrder($where: PurchaseOrderDetailWhereInputOne!, $data: PurchaseOrderDetailInput) {
  buyPurchaseOrder(where: $where, data: $data) {
    id
  }
}
`

export const CONFIRM_PURCHASE_ORDER = gql`
  mutation ConfirmPurchase($where: PurchaseOrderDetailWhereInputOne!, $data: PurchaseOrderDetailInput) {
    confirmPurchase(where: $where, data: $data)
  }
`